import Entity from './entity'
export default class Inairequipment extends Entity<number>{
    Id:number;
    status:Number=1;
    ftId:Number;
    wId:Number;
    fId:Number;
    gId:Number;
    cId:Number;
    updateInterval:Object;
    AcquisitionInterval:number;
}